import { RefObject, useLayoutEffect } from 'react'
import { gsap } from 'gsap'
import { playVerifyEmailIllustration } from './verifyEmailAnimations'

interface VerifyEmailAnimationRefs {
  paperRef: RefObject<SVGGElement | null>
  checkmarkRef: RefObject<SVGGElement | null>
}

/** Plays the verify-email illustration's mount animation once on render. */
export const useVerifyEmailAnimation = ({
  paperRef,
  checkmarkRef,
}: VerifyEmailAnimationRefs) => {
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      playVerifyEmailIllustration({
        paper: paperRef.current,
        checkmark: checkmarkRef.current,
      })
    })

    return () => ctx.revert()
  }, [paperRef, checkmarkRef])
}
